import { all, put, SagaIterator, takeEveryCompletedRequest, takeEveryErrorRequest } from './core/sagaEffects';
import { AddNotification, FetchRequest } from 'acscp/actions';
import { ResponseErrorTypes, ResponseType } from 'acscp/api/responses/core/responseTypes';
import { ErrorDetails } from 'acscp/api/models/errorDetails';
import { AccountLinksRequest, AddAccountLinkRequest } from 'acscp/api/requests';
import { NotificationDuration, NotificationType } from 'acscp/store/notificationState';
import { defineMessages } from 'react-intl';
import { getTranslatableErrorMessage } from 'acscp/components/common/helpers/getTranslatableErrorMessage';

const messages = defineMessages({
    success: {
        id: 'sagas.addAccountLinkSaga.successNotification',
        defaultMessage: 'Thank you for submitting your share request. A confirmation email will be sent to you, ' +
                        'the individual you have shared with and your Account Manager shortly.'
    }
});

const addAccountLinkRequestSuccess = 'addAccountLinkRequestSuccess';
const addAccountLinkRequestFailureCause = 'addAccountLinkRequestFailureCause';

export function* addAccountLinkSaga(): SagaIterator {
    yield all([
        takeEveryCompletedRequest(AddAccountLinkRequest, handleAddAccountLinkRequestSuccess),
        takeEveryErrorRequest(AddAccountLinkRequest, handleAddAccountLinkRequestErrors)
    ]);
}

export function* handleAddAccountLinkRequestSuccess(
    response: undefined,
    request: AddAccountLinkRequest
): SagaIterator {
    yield put(new FetchRequest(new AccountLinksRequest()));
    yield put(new AddNotification(addAccountLinkRequestSuccess, messages.success, NotificationType.Info, NotificationDuration.Long));
}

export function* handleAddAccountLinkRequestErrors(
    responseType: ResponseErrorTypes,
    error: ErrorDetails,
    request: AddAccountLinkRequest
): SagaIterator {
    if (responseType === ResponseType.RequestError) {
        yield put(new FetchRequest(new AccountLinksRequest()));
        yield put(new AddNotification(
            addAccountLinkRequestFailureCause, getTranslatableErrorMessage(error.message), NotificationType.Error));
    }
}
